import React from 'react';
import { Grid, makeStyles, Typography, createStyles, Theme as AugmentedTheme } from '@material-ui/core';

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    blockHolder: {
        height: '100vh',
    },
    blockControlHolder: {
        maxWidth: '640px',
        width: '100%',
    },
    //@ts-ignore
    formControl: theme.formControl,
    //@ts-ignore
    formControlBorder: theme.formControlBorder,
    formTitle: theme.formTitle,
    formDescription: theme.formDescription,
}))

export default function Error() {
    const classes = useStyles();

    return(
        <Grid container direction="column" alignItems="center" className={classes.blockHolder}>
            <Grid className={classes.blockControlHolder}>
                <Grid container direction="column" className={`${classes.formControl} ${classes.formControlBorder}`}>
                    <Typography variant="h1" className={classes.formTitle}>Error!</Typography>
                    <Typography className={classes.formDescription}>Try again, thanks!</Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}
